import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import fa from "vuetify/es5/locale/fa";
import en from "vuetify/es5/locale/en";

// import colors from 'vuetify/lib/util/colors';
import colors from "@/assets/sass/variables/colors.js";

Vue.use(Vuetify);

const language = localStorage.getItem("lang", "fa");
const isDark = localStorage.getItem("theme") === "dark";
console.log("language", language);
export default new Vuetify({
  theme: {
    // dark: window.matchMedia("(prefers-color-scheme: dark)").matches,
    dark: isDark,
    themes: {
      light: {
        P1: colors.light.P1,
        P2: colors.light.P2,

        S1: colors.light.S1,
        S2: colors.light.S2,


        BG1: colors.light.BG1,
        BG2: colors.light.BG2,
        BG3: colors.light.BG3,

        G1: colors.light.G1,
        G2: colors.light.G2,
        G3: colors.light.G3,
        G4: colors.light.G4,
        G5: colors.light.G5
      },
      dark: {
        P1: colors.dark.P1,
        P2: colors.dark.P2,

        S1: colors.dark.S1,
        S2: colors.dark.S2,

        BG1: colors.dark.BG1,
        BG2: colors.dark.BG2,
        BG3: colors.dark.BG3,

        G1: colors.dark.G1,
        G2: colors.dark.G2,
        G3: colors.dark.G3,
        G4: colors.dark.G4,
        G5: colors.dark.G5
      }
    },
  },
  lang: {
    locales: { fa, en },
    current: "fa",
  },
  rtl: !language || language === "fa" ? true : false,
});
